// migrated 1:1 from @nexato/nx-core-module, #688
import { User } from "../../../entities/user/user";
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-issue-assigned',
  template: `
    <ng-container *ngIf="assignee(); else noAssignee">
    <b>{{activity()?.actor?.displayName}}</b> hat an <b>{{assignee()?.displayName}}</b> zugewiesen <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-container>
    <ng-template #noAssignee>
      <b>{{activity()?.actor?.displayName}}</b> hat die Zuweisung entfernt <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-template>
  `
})
export class IssueAssignedComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  readonly assignee = computed(() => {
    const activity = this.activity();
    if (activity?.viewModel?.assignee) {
      return new User(activity.viewModel.assignee);
    }
    return undefined;
  });
}
